import { render, staticRenderFns } from "./productsStatistics.vue?vue&type=template&id=777befe1&"
import script from "./productsStatistics.vue?vue&type=script&lang=js&"
export * from "./productsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./productsStatistics.vue?vue&type=style&index=0&id=777befe1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777befe1')) {
      api.createRecord('777befe1', component.options)
    } else {
      api.reload('777befe1', component.options)
    }
    module.hot.accept("./productsStatistics.vue?vue&type=template&id=777befe1&", function () {
      api.rerender('777befe1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/products/productsStatistics.vue"
export default component.exports